export function cleanup(pilet) {
    const css = document.querySelector(`link[data-origin=${JSON.stringify(pilet.name)}]`);
    css === null || css === void 0 ? void 0 : css.remove();
    // check if this was actually set up using a require reference
    if ('requireRef' in pilet) {
        const depName = pilet.requireRef;
        delete window[depName];
    }
}
//# sourceMappingURL=cleanup.js.map